<template lang="pug">
section
  v-layout(wrap)
    v-flex(xs12)
      v-select(
        @input='$emit("update", block)',
        v-model='block.meta.variant',
        :items='variants',
        item-value='type',
        item-text='name',
        label='Вариант списка',
        returnObject
      )
    v-flex(xs12)
      .dflex.dflex-center(v-for='(_, index) in block.value', :key='index')
        .dflex-item
          v-textarea.pa-0.ma-0(
            rows='2',
            v-model='block.value[index]',
            @input='$emit("update", block)'
          )
        .dflex-auto
          v-btn.mr-0(icon, @click.stop='remove(index)')
            v-icon(small) delete_outline
  v-btn.ml-0(@click.stop='add', small, depressed)
    v-icon(left, small) add
    | Добавить
</template>

<script>
import BaseBlock from './BaseBlock'
import PropTypes from '@znck/prop-types'
export default {
  extends: BaseBlock,

  props: {
    block: PropTypes.shape({
      type: PropTypes.string.isRequired,
      value: PropTypes.array,
    }),
  },

  data: () => ({
    variants: [
      {
        type: 'ul',
        name: 'Маркированный список',
      },
      {
        type: 'ol',
        name: 'Нумерованный список',
      },
    ],
  }),

  mounted() {
    if (0 === this.block.value.length) {
      this.add()
    }
  },

  methods: {
    add() {
      this.block.value.push('')
      this.$nextTick(() => {
        const inputs = [...this.$el.querySelectorAll('input')]
        inputs[inputs.length - 1].focus()
      })
    },

    remove(index) {
      this.block.value.splice(index, 1)
    },
  },
}
</script>
